<template>
  <div class="home">
    <h2 class="home-header fadein d100ms">Willkommen zurück, <i>{{ displayName }}</i>!</h2>
    <div class="home-subtitle fadein d100ms">Statistiken und Übersichten über Fantasyroom Reklamationen</div>
    <br>
    <Panel v-if="authStore.hasUserPermission('warehouse.view')">
<WarehouseReclamationSearch></WarehouseReclamationSearch>
    </Panel>
    <br>
    <Panel v-if="authStore.hasUserPermission('customerservice.view')">
<CustomerServiceReclamationSearch></CustomerServiceReclamationSearch>
    </Panel>
    <br>
    <Panel v-if="authStore.hasUserPermission('accounting.warehouse.view')">
<Accounting_WarehouseReclamationSearch></Accounting_WarehouseReclamationSearch>
    </Panel>
    <br>
    <Panel v-if="authStore.hasUserPermission('accounting.customerservice.view')">
      <Accounting_CustomerServiceReclamationSearch></Accounting_CustomerServiceReclamationSearch>
    </Panel>
    <br>
      <Panel v-if="authStore.hasUserPermission('warehouse.followupdeliveries.view')">
      <Followupdeliveries></Followupdeliveries>
      </Panel>
    <br>
  </div>
</template>

<script>
import { getAuth } from "firebase/auth";
import axios from "axios";
import { config } from "../assets/config.js";
import Panel from "primevue/panel";

import { useAuthStore } from "@/stores/auth.js";
import WarehouseReclamationSearch from "./pages/warehouse/WarehouseReclamationSearch.vue";
import CustomerServiceReclamationSearch from "./pages/customerservice/CustomerServiceReclamationSearch.vue";
import Accounting_WarehouseReclamationSearch from "./pages/accounting/Accounting_WarehouseReclamationSearch.vue";
import Accounting_CustomerServiceReclamationSearch from "./pages/accounting/Accounting_CustomerServiceReclamationSearch.vue";
import Followupdeliveries from "./pages/warehouse/Followupdeliveries.vue";

export default {
  components: {
    Panel,
    WarehouseReclamationSearch,
    CustomerServiceReclamationSearch,
    Accounting_WarehouseReclamationSearch,
    Accounting_CustomerServiceReclamationSearch,
    Followupdeliveries
  },
  data() {
    return {
      authStore: useAuthStore(),
      displayName: '',
    };
  },

  async mounted() {
    try {
      const response = await axios.get(config.api_url + "/api/user/getDisplayName", {
        headers: {
          Authorization: await getAuth().currentUser.getIdToken(),
        },
      });

      this.displayName = response.data.displayname;
    } catch (error) {
      console.error("Error fetching display name:", error);
    }
  }

};
</script>

<style lang="scss" scoped>
.home {
  &-header {
    margin-bottom: 0;
  }

  &-subtitle {
    color: rgb(192, 192, 192);
  }
}

.chart-container {
  position: absolute;
  top: 100px;
  left: 320px;
  width: 630px;
  height: 400px;
}
</style>
